/* eslint-disable react-hooks/exhaustive-deps */
import { Breadcrumb, Button, message, Modal, Form } from 'antd';
import i18next from 'i18next';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { filterForm, getInputLabel, mapFormGroup } from '../../helper';
import { CategorieList } from '../components/categories';
import { Sections } from '../components/sections';
import moment from 'moment';
import _ from 'lodash';
import { EditForm } from '../../form';
import { FileDoneOutlined } from '@ant-design/icons';
import { MessageTypes } from '../../../../helpers/Messages';
import Loading from '../../../../components/Loading';
import styled from 'styled-components';
import { isProxy } from 'datastake-daf/src/helpers/Token';
import PageHeader from '../../../../components/Layout/PageHeader';

const Definition = styled.div`
  background: white;
  border-radius: 4px;
  padding: var(--size-lg);
  background: white;
  margin-bottom: var(--size-lg);
  box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.18);

  label {
    margin-bottom: 0px;
    font-weight: 500;
  }

  h1 {
    font-weight: 700;
  }
`;

const getMeasures = (form) => {
  if (form && form.options && form.options.legality) {
    const { forms } = form.options.legality;
    if (forms && forms.contamination && forms.contamination.planning) {
      if (forms.contamination.planning.planning) {
        if (forms.contamination.planning.planning.inputs) {
          if (forms.contamination.planning.planning.inputs.measure) {
            return forms.contamination.planning.planning.inputs.measure.options;
          }
        }
      }
    }
  }
  return [];
}

export function Risk({
  conf: {
    group = null,
    form = {},
    data = {},
    linkingForms,
    match,
    module,
    formConfig: fConf = {},
    getViewLink = () => { },
    pageHeaderExtra,
    actions,
    language,
    submitCall,
    namespace,
    viewGet,
    id
  },
  user
}) {
  const [MainForm] = Form.useForm();
  const { position, label, showFormIf, template, excludeFromEdit, ...subSections } = form;
  const goTo = useNavigate();
  const [, contextHolder] = Modal.useModal();
  const params = useParams();
  const [subsection, setSubSection] = useState(params.subsection);
  const [subgroup, setSubGroup] = useState(params.subgroup);
  const [formid, setFormId] = useState(params.formid);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [subCategories, setSubCategories] = useState([]);
  const [formSections, setFormSections] = useState([]);
  const [formPath, setFormPath] = useState([]);
  const formConfig = fConf;
  const [selectedForm, setSelectedForm] = useState({});
  const [values, setValues] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [editValues, setEditValues] = useState({});
  const [changedPath, setChangedPath] = useState([]);
  const [originalData,] = useState({});
  const [hasSubSections,] = useState([]);

  const measureOptions = useMemo(() =>
    formid === 'management' ? getMeasures(form) : [], [form, formid]);

  const isArrayOfObjects = (arr) => Array.isArray(arr) && arr
    .map(i => typeof i === 'object')
    .every(i => i);

  const locationName = useMemo(() => {
    if (data) {
      if (data.locationName) {
        return data.locationName;
      }
    }
    return null;
  }, [data]);

  const hasNotChanged = (old, newData) => {
    return _.union(Object.keys(old), Object.keys(newData))
      .map(key => {
        switch (typeof newData[key]) {
          case undefined:
            return true;
          case 'object':
            try {
              if (moment.isMoment(newData[key])) {
                if (typeof newData[key].format === 'function') {
                  return old[key] === newData[key].format('YYYY-MM-DD');
                }
                return old[key] === moment(newData[key]._d).format('YYYY-MM-DD');
              } else if (isArrayOfObjects(newData[key])) {
                return newData[key].length === (old[key] || []).length && newData[key].map((oKey, i) => hasNotChanged((old[key] || [])[i] || {}, oKey || {})).every(i => i);
              }
            } catch (e) {
              console.log(e, data[key], key);
            }
            return _.isEqual(old[key], newData[key]);
          case 'number':
          case 'string':
          case 'boolean':
            return old[key] === newData[key];
          default:
            return true;
        }
      }).every(key => key);
  }
  // params
  useEffect(() => {
    setSubSection(params.subsection);
    setSubGroup(params.subgroup);
    setFormId(params.formid);
  }, [params]);

  useEffect(() => {
    if (editValues.id !== values.id) {
      setValues({
        ...editValues,
        ...values,
      });
    } else if (!isLoading) {
      setValues({
        ...values,
        ...editValues,
      });
    }
  }, [selectedForm])
  useEffect(() => {
    let rdata = [];
    let subCategoryData = editValues;
    if (data.risk && data.risk[subsection]) {
      rdata = data.risk[subsection];
      const sData = (rdata || []).find(r => r.subCategory === subgroup);
      if ((Object.keys(editValues).length === 0 || editValues.id !== sData.id)) {
        subCategoryData = sData;
        const { config = [], ...riskData } = (subCategoryData || {});

        if (config && Array.isArray(config)) {
          const { assessment = {}, management = [], planning = [], otherPlanning = [] } = config.length ? config[(config.length - 1)] : {};
          setValues({
            country: data.country,
            config,
            ...riskData,
            assessment,
            management,
            planning,
            otherPlanning,
          })
        }
      }
    }
    if (form && form.options) {
      const { options } = form;
      if (!subsection) {
        setCategories(Object.keys(options).map(o => {
          const { label, disabled } = options[o];
          return {
            value: o,
            label,
            disabled
          }
        }))
      } else if (!subgroup) {
        const category = options[subsection] || {}
        setSelectedCategory({
          value: subsection,
          label: category.label || ''
        });
        const { inputs } = category;
        if (inputs && inputs.subCategory && inputs.subCategory.options) {
          setSubCategories(inputs.subCategory.options || []);
        }
      } else {
        const category = options[subsection] || {};
        const subCategory = (category.forms || {})[subgroup] || {};
        const grForms = mapFormGroup(subCategory).map(gf => {
          gf.show = filterForm(gf, subCategoryData);
          return gf;
        });
        setFormSections(grForms);
      }
    }
    setIsLoading(false);
  }, [form, group, subsection, subgroup, formid, data]);
  useEffect(() => {
    const formPaths = formSections.filter(f => f.show && !f.excludeFromEdit).reduce((paths, item) => {
      if (item.items) {
        Object.keys(item.items).forEach(i => {
          paths.push(`${item.id}/${i}`);
        })
      } else {
        paths.push(item.id);
      }
      return paths;
    }, []);
    setFormPath(formPaths);
  }, [formSections])
  useEffect(() => {
    if (formid === 'identification' && Object.keys(editValues).length) {
      const { options } = form;
      const category = options[subsection] || {};
      const subCategory = (category.forms || {})[subgroup] || {};
      const grForms = mapFormGroup(subCategory).map(gf => {
        gf.show = filterForm(gf, editValues);
        return gf;
      });
      setFormSections(grForms);
    }
  }, [editValues])
  const saveData = () => {
    setIsLoading(true);
    const { _id, ...payloadData } = { ...editValues, subjectId: data.id, module, view: viewGet[namespace] };
    const callback = (type, m) => {
      if (type === MessageTypes.SUCCESS) {
        message.success(m);
        goTo(getViewLink());
      } else {
        message.error(m);
      }
    }
    submitCall.risk[namespace]((!editValues && !editValues.id)
      ? payloadData
      : Object.assign(payloadData, { id: values.id }), callback);

  }
  const cInd = formPath.findIndex(p => p === formid);
  const getNextLink = () => {
    if (formPath.length > 0 && cInd > -1 && (cInd + 1) < formPath.length) {
      const newPath = formPath[(cInd + 1)];
      const mode = isProxy() ? 'proxy' : 'app';
      return `/${mode}/${module}/edit/${namespace}/${id}/${group}/${subsection}/${subgroup}/${newPath}`;
    }
    return false;
  }

  const saveAndNext = () => {
    setIsLoading(true);
    const { _id, ...payloadData } = { ...editValues, subjectId: data.id, module, view: viewGet[namespace] };
    setEditValues({});
    const callback = (type, m) => {
      if (type === MessageTypes.SUCCESS) {
        message.success(m);
        setIsChanged(false);
        const newPath = getNextLink();
        if (newPath) {
          goTo(newPath);
        }
      } else {
        message.error(m);
      }
    }
    submitCall.risk[namespace]((!editValues && !editValues.id)
      ? payloadData
      : Object.assign(payloadData, { id: values.id }), callback, id);

  }

  const modalConfig = {
    title: i18next.t('Risk score has changed'),
    content: (
      <>
        {i18next.t('vulnerabilityChangedText')}
      </>
    ),
    centered: true,
    okText: i18next.t('Ok'),
    cancelText: i18next.t('Cancel'),
    wrapClassName: 'without-cancel',
    onOk: () => saveData(),
  };

  const onSubmitData = () => {
    const { assessment = {} } = editValues;
    const { assessment: oldAssessment = {} } = values;
    if (oldAssessment.vulnerability && oldAssessment.vulnerability !== assessment.vulnerability) {
      modalConfig.onOk = () => saveData();
      Modal.confirm(modalConfig);
    } else {
      saveData();
    }
  }
  const onSaveAndNext = () => {
    const { assessment = {} } = editValues;
    const { assessment: oldAssessment = {} } = values;
    if (oldAssessment.vulnerability && oldAssessment.vulnerability !== assessment.vulnerability) {
      modalConfig.onOk = () => saveAndNext();
      Modal.confirm(modalConfig);
    } else {
      saveAndNext();
    }
  }

  const getSubGroupTitle = () => {
    const option = (
      subSections.options &&
        subSections.options[subsection] &&
        subSections.options[subsection].inputs &&
        subSections.options[subsection].inputs.subCategory &&
        subSections.options[subsection].inputs.subCategory.options &&
        Array.isArray(subSections.options[subsection].inputs.subCategory.options) ?
        subSections.options[subsection].inputs.subCategory.options : []
    )
      .find(item => item.value === subgroup);
    return option ? option.label : 'Not Found'
  }

  const definition = useMemo(() => {
    if (form && form.options && (formid === 'identification' || formid === 'assessment')) {
      if (form.options[subsection]) {
        if (form.options[subsection].forms) {
          if (form.options[subsection].forms[subgroup]) {
            const item = form.options[subsection].forms[subgroup];
            if (item.definition) {
              return item.definition;
            }
          }
        }
      }
    }
    return null;
  }, [form, subgroup, subsection, formid]);

  const renderDefintion = useMemo(() => (
    <>
      {definition && (
        <Definition>
          <h1>{i18next.t('About this risk')}</h1>
          <label>
            {definition}
          </label>
        </Definition>
      )}
    </>
  ), [definition]);

  return isLoading ? <Loading /> : <React.Fragment>
    <PageHeader
      title={
        <Breadcrumb separator="/">
          <Breadcrumb.Item>{i18next.t('Risk')}</Breadcrumb.Item>
          <Breadcrumb.Item
            className="tablesaw-sortable-btn"
            onClick={() => {
              const link = getViewLink().split(`/${subgroup}`)[0];
              goTo(`${link}/${subgroup}`)
              goTo(link);
            }}>
            {subSections.options && subSections.options[subsection]
              ? getInputLabel(subSections.options[subsection], values) : ''}
          </Breadcrumb.Item>
          <Breadcrumb.Item
            className="tablesaw-sortable-btn"
            onClick={() => goTo(getViewLink())}>
            {getSubGroupTitle()}
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      onBack={() => {
        const link = getViewLink().split(`/${subgroup}`)[0];
        goTo(`${link}/${subgroup}`)
        goTo(link);
      }}
      extra={[
        ...pageHeaderExtra,
        <div key="page-heade-actions" className="actions">
          {actions.map((action, i) => (
            <Button
              key={`a-${i}`}
              style={{ '--color': action.color }}
              icon={<action.icon />}>
              {action.label[language]}
            </Button>
          ))}
          <Button
            key="view-changes"
            className="sca-btn"
            onClick={() => goTo(getViewLink())}>
            {i18next.t('Cancel')}
          </Button>
          <Button
            key="save-changes"
            type="primary"
            className="sca-btn"
            onClick={onSaveAndNext}
            disabled={!isChanged}>
            {i18next.t('Save')}
          </Button>
          <Button
            key="save-and-continue"
            type="primary"
            className="sca-btn submit"
            icon={<FileDoneOutlined />}
            onClick={onSubmitData}
            disabled={!isChanged}
          >
            {i18next.t('Submit')}
          </Button>
        </div>
      ]} />
    <div className="view-content">
      <div className={`risk-template content ${subsection && subgroup ? 'no-padding' : ''}`}>
        {!subsection || !subgroup ?
          <CategorieList
            categories={!subsection ? categories : subCategories}
            subsection={subsection}
            category={selectedCategory}
            match={match}
            group={group}
          /> : <React.Fragment>
            <Sections
              group={formid}
              formConf={formSections}
              mod={module}
              values={values}
              match={match}
              onChangeForm={(sForm) => {
                if (sForm) {
                  if (sForm.id === 'management') {
                    setSelectedForm({ ...sForm, locationName, measureOptions });
                  } else {
                    setSelectedForm({ ...sForm, locationName, measureOptions });
                  }
                }
              }}
            ></Sections>
            {contextHolder}
            <EditForm
              MainForm={MainForm}
              definition={renderDefintion}
              onValuesChange={(val, all, isTransfer) => {
                if (isTransfer) {
                  if (val.otherPlanning) {
                    setValues({
                      ...values,
                      otherPlanning: val.otherPlanning,
                    });
                    setEditValues((prev) => ({ ...prev, ...values, ...val }));
                  }
                  if (val.management) {
                    setValues({
                      ...values,
                      management: val.management,
                    });
                    setEditValues((prev) => ({ ...prev, ...values, ...val }));
                  }
                  if (val.planning) {
                    setValues({
                      ...values,
                      planning: val.planning,
                    });
                    setEditValues((prev) => ({ ...prev, ...values, ...val }));
                  }
                  setIsChanged(true);
                  return;
                }
                if (val.isRiskRelevant === 'no') {
                  if (all.assessment && Object.keys(all.assessment).length === 0) {
                    all.assessment.impact = 1;
                    // all.assessment.vulnerability = 1;
                    all.assessment.threat = 1;
                    setValues({
                      ...values,
                      assessment: all.assessment
                    });
                  }
                }
                if (val.assessment) {
                  if (
                    all.isRiskRelevant === 'no' &&
                    (
                      (val.assessment.impact && val.assessment.impact !== 1) ||
                      //val.assessment.vulnerability !== 1 ||
                      (val.assessment.threat && val.assessment.threat !== 1)
                    )
                  ) {
                    all.isRiskRelevant = 'yes';
                    Modal.info({
                      content: i18next.t('changeRiskRelevantToYes')
                    });
                    setValues({
                      ...values,
                      isRiskRelevant: 'yes'
                    });
                  }
                }
                setEditValues(all);
                const keys = val && typeof val === 'object' ? Object.keys(val) : [];
                if (keys.length === 1) {
                  const changedKey = keys[0];
                  const ogData = originalData[changedKey];
                  const newData = all[changedKey];
                  let changePath = JSON.parse(JSON.stringify(changedPath));
                  if (!hasNotChanged({ [changedKey]: ogData }, { [changedKey]: newData })) {
                    if (!changePath.includes(changedKey)) {
                      changePath.push(changedKey);
                    }
                  } else {
                    changePath = changePath.filter(k => k !== changedKey);
                  }
                  setChangedPath([
                    ...changePath
                  ]);
                  setIsChanged(changePath.length > 0 ? true : false);
                } else {
                  setIsChanged(true);
                }
              }}
              disabledInputs={formConfig.disabledInputs || []}
              excludedKeys={formConfig.disabledInputs || []}
              hasSections={hasSubSections}
              linkingForms={linkingForms}
              form={selectedForm}
              data={values}
              allData={data}
              subGroupTitle={getSubGroupTitle()}
              template="RISK"
            />
          </React.Fragment>}
      </div>
    </div>
  </React.Fragment>
};
